import { ImpactModule } from 'types'
import { CITIZEN_PROFILE_PAGES } from './pages'
import { CITIZEN_PROFILE_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const CITIZEN_PROFILE_MODULE: ImpactModule = {
  NAME: 'integrated-profile',
  NAME_PTBR: 'Perfil Cidadão',
  UPPER_NAME: 'INTEGRATED_PROFILE',
  API_NAME: 'INTEGRATED_PROFILE',
  PAGES: CITIZEN_PROFILE_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: CITIZEN_PROFILE_PAGES_ORDER_FOR_PERMISSIONS,
}
